import { render, staticRenderFns } from "./TransactionCategorySettingsShimmer.vue?vue&type=template&id=9a52acb6&"
import script from "./TransactionCategorySettingsShimmer.vue?vue&type=script&lang=js&"
export * from "./TransactionCategorySettingsShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports